import React, { useState } from "react";
import { Row, Col, Spin, Form, Card, DatePicker } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { rightAction } from "../../../../redux/actions";
import { labelConfig, staticConfig, apiConfig } from "../../treasuryContractBooking.config";
import { BOM } from "../../../../services/definedMethod";

const Tip = ({ text, tip }) => (
  <span>
    {text}
    <Tooltip title={tip}>
      <InfoCircleOutlined style={{ marginLeft: 4, color: "#667085" }} />
    </Tooltip>
  </span>
);

const CallablePrematureRedemption = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const contractId = location.state;
  const { userData } = props;
  const { session } = userData || {};

  const onFinish = (values) => {
    setIsLoading(true);

    const body = {
      session,
      locale: "en",
      dateFormat: "dd MMM yyyy",
      method: "POST",
      redemptionDate: values.redemptionDate?.format("DD MMM YYYY"),
    };

    const url = `${apiConfig.GetBondContracts}/${contractId}/premature-redemption`;

    BOM.FetchReqAction(body, url, (err) => {
      if (err) {
        BOM.AlertMsg(
          cnt.DANGER,
          err?.errors?.[0]?.defaultUserMessage ||
            err?.defaultUserMessage ||
            "Failed to process redemption."
        );
        setIsLoading(false);
        return;
      }

      BOM.AlertMsg(cnt.SUCCESS, "Premature redemption processed successfully.");
      setIsLoading(false);
      navigate(-1);
    });
  };

  return (
    <MainLayout pageItems={staticConfig.manageBondContract}>
      <TopContent pageTitle={labelConfig.bondContractListing} />

      <Spin spinning={isLoading} size="large">
        <div style={{ padding: "24px" }}>
          <Card style={{ boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)", borderRadius: 20 }}>
            <h3 style={{ marginBottom: 4, fontWeight: 600 }}>Premature Redemption (Callable)</h3>
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Row>
                <Col span={12} style={{ padding: "0 8px" }}>
                  <Form.Item
                    label={
                      <Tip
                        text="Redemption Date"
                        tip="The date on which the bond is redeemed early."
                      />
                    }
                    name="redemptionDate"
                    rules={[{ required: true, message: "Redemption date is required" }]}
                  >
                    <DatePicker
                      style={{ width: "100%", height: 44 }}
                      format="DD MMM YYYY"
                      placeholder="e.g. 02 MAY 2026"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <div style={{ borderTop: "1px solid #EAECF0", margin: "8px 0 20px" }} />

              <Row justify="end">
                <Col>
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    style={{
                      height: 44, padding: "0 24px", borderRadius: 8,
                      border: "1px solid #D0D5DD", background: "#fff",
                      color: "#344054", fontWeight: 600, fontSize: 14,
                      cursor: "pointer", marginRight: 12,
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={() => form.submit()}
                    style={{
                      height: 44, padding: "0 24px", borderRadius: 8,
                      border: "1px solid #BA24D5", background: "#BA24D5",
                      color: "#fff", fontWeight: 600, fontSize: 14, cursor: "pointer",
                    }}
                  >
                    Submit Redemption
                  </button>
                </Col>
              </Row>

              <button type="submit" hidden />
            </Form>
          </Card>
        </div>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  rightBtn: state.RightSideBtn,
  userData: state.AuthenticationData.userData,
});

export default connect(mapStateToProps, { rightAction })(CallablePrematureRedemption);